export const areSettingsChanged = (settings, initialState) => Object.keys(settings).some((key) => settings[key] !== initialState[key]);

export const findChangedSettings = (settings, initialState) => {
  const changedSettings = Object.keys(settings).reduce((acc, currKey) => {
    if (settings[currKey] !== initialState[currKey]) {
      return {
        ...acc,
        [currKey]: settings[currKey],
      };
    }
    return acc;
  }, {});
  return changedSettings;
};

export const findMatchingSettingEnum = (settingOptions, settingValue) =>
  settingOptions.find((setting) => setting.value === settingValue) || settingOptions[0];
